
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, CustomerConfiguration_$reflection, RequestedValue$1_$reflection, ProcedureId_$reflection } from "../../Shared/Shared.js";
import { DTO_ProcedureFormDto_$reflection } from "../../Shared/Procedure.js";
import { Storage_$reflection } from "../../Shared/Storage.js";
import { union_type, string_type, class_type, record_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { PropertyConfiguration_$reflection } from "../../Shared/PropertyConfiguration.js";

export class State extends Record {
    constructor(ProcedureId, ProcedureForm, Storages, PropertyConfigurations, CustomerConfiguration, FormState) {
        super();
        this.ProcedureId = ProcedureId;
        this.ProcedureForm = ProcedureForm;
        this.Storages = Storages;
        this.PropertyConfigurations = PropertyConfigurations;
        this.CustomerConfiguration = CustomerConfiguration;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Procedure.Results.Types.State", [], State, () => [["ProcedureId", ProcedureId_$reflection()], ["ProcedureForm", RequestedValue$1_$reflection(DTO_ProcedureFormDto_$reflection())], ["Storages", list_type(Storage_$reflection())], ["PropertyConfigurations", list_type(PropertyConfiguration_$reflection())], ["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ProcedureFormFetched", "StoragesFetched", "PropertyConfigurationsFetched", "CustomerConfigurationFetched", "FetchError", "GeneratePdf", "AttachProtocolPdf", "ProtocolPdfAttached", "PdfGenerated", "BlobReceived"];
    }
}

export function Msg_$reflection() {
    return union_type("Procedure.Results.Types.Msg", [], Msg, () => [[["Item", DTO_ProcedureFormDto_$reflection()]], [["Item", list_type(Storage_$reflection())]], [["Item", list_type(PropertyConfiguration_$reflection())]], [["Item", CustomerConfiguration_$reflection()]], [["Item", class_type("System.Exception")]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item1", class_type("Fetch.Types.Response")], ["Item2", string_type]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]]]);
}

